"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FullScreenModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _react2 = require("@emotion/react");
var _core = require("../../core");
var _theme = require("../../system/theme");
var _ODThemeLite = require("../../theme/ODThemeLite");
var _NavigationBar = require("./NavigationBar");
var _shared = require("./shared");
var _excluded = ["isOpen", "onRequestClose", "headerIconButtonVariant", "title", "subtitle", "id", "analyticsName", "trackBoxImpression", "trackButtonImpressions", "onBackClick", "showScrollbar", "hasPadding", "themeProps"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function cov_k86gbahkc() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Modal/FullScreenModal.tsx";
  var hash = "9be16e18595f2286e9f928f2c27633fca81b0ab1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Modal/FullScreenModal.tsx",
    statementMap: {
      "0": {
        start: {
          line: 59,
          column: 25
        },
        end: {
          line: 59,
          column: 28
        }
      },
      "1": {
        start: {
          line: 60,
          column: 27
        },
        end: {
          line: 64,
          column: 1
        }
      },
      "2": {
        start: {
          line: 65,
          column: 27
        },
        end: {
          line: 69,
          column: 1
        }
      },
      "3": {
        start: {
          line: 71,
          column: 63
        },
        end: {
          line: 210,
          column: 1
        }
      },
      "4": {
        start: {
          line: 87,
          column: 25
        },
        end: {
          line: 87,
          column: 91
        }
      },
      "5": {
        start: {
          line: 88,
          column: 20
        },
        end: {
          line: 88,
          column: 63
        }
      },
      "6": {
        start: {
          line: 89,
          column: 2
        },
        end: {
          line: 89,
          column: 32
        }
      },
      "7": {
        start: {
          line: 90,
          column: 40
        },
        end: {
          line: 90,
          column: 55
        }
      },
      "8": {
        start: {
          line: 91,
          column: 23
        },
        end: {
          line: 94,
          column: 3
        }
      },
      "9": {
        start: {
          line: 92,
          column: 11
        },
        end: {
          line: 92,
          column: 56
        }
      },
      "10": {
        start: {
          line: 96,
          column: 21
        },
        end: {
          line: 96,
          column: 31
        }
      },
      "11": {
        start: {
          line: 98,
          column: 45
        },
        end: {
          line: 107,
          column: 3
        }
      },
      "12": {
        start: {
          line: 109,
          column: 45
        },
        end: {
          line: 121,
          column: 3
        }
      },
      "13": {
        start: {
          line: 123,
          column: 23
        },
        end: {
          line: 144,
          column: 3
        }
      },
      "14": {
        start: {
          line: 146,
          column: 2
        },
        end: {
          line: 209,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 71,
            column: 63
          },
          end: {
            line: 71,
            column: 64
          }
        },
        loc: {
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 210,
            column: 1
          }
        },
        line: 86
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 5
          }
        },
        loc: {
          start: {
            line: 92,
            column: 11
          },
          end: {
            line: 92,
            column: 56
          }
        },
        line: 92
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 72,
            column: 2
          },
          end: {
            line: 72,
            column: 16
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 72,
            column: 11
          },
          end: {
            line: 72,
            column: 16
          }
        }],
        line: 72
      },
      "1": {
        loc: {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 74,
            column: 34
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 74,
            column: 28
          },
          end: {
            line: 74,
            column: 34
          }
        }],
        line: 74
      },
      "2": {
        loc: {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 82,
            column: 22
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 82,
            column: 18
          },
          end: {
            line: 82,
            column: 22
          }
        }],
        line: 82
      },
      "3": {
        loc: {
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 83,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 83,
            column: 15
          },
          end: {
            line: 83,
            column: 19
          }
        }],
        line: 83
      },
      "4": {
        loc: {
          start: {
            line: 87,
            column: 25
          },
          end: {
            line: 87,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 87,
            column: 33
          },
          end: {
            line: 87,
            column: 64
          }
        }, {
          start: {
            line: 87,
            column: 67
          },
          end: {
            line: 87,
            column: 91
          }
        }],
        line: 87
      },
      "5": {
        loc: {
          start: {
            line: 88,
            column: 20
          },
          end: {
            line: 88,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 88,
            column: 37
          },
          end: {
            line: 88,
            column: 41
          }
        }, {
          start: {
            line: 88,
            column: 44
          },
          end: {
            line: 88,
            column: 63
          }
        }],
        line: 88
      },
      "6": {
        loc: {
          start: {
            line: 185,
            column: 23
          },
          end: {
            line: 185,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 185,
            column: 23
          },
          end: {
            line: 185,
            column: 30
          }
        }, {
          start: {
            line: 185,
            column: 34
          },
          end: {
            line: 185,
            column: 45
          }
        }],
        line: 185
      },
      "7": {
        loc: {
          start: {
            line: 191,
            column: 13
          },
          end: {
            line: 191,
            column: 31
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 191,
            column: 26
          },
          end: {
            line: 191,
            column: 27
          }
        }, {
          start: {
            line: 191,
            column: 30
          },
          end: {
            line: 191,
            column: 31
          }
        }],
        line: 191
      },
      "8": {
        loc: {
          start: {
            line: 196,
            column: 12
          },
          end: {
            line: 202,
            column: 17
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 197,
            column: 16
          },
          end: {
            line: 197,
            column: 18
          }
        }, {
          start: {
            line: 198,
            column: 16
          },
          end: {
            line: 202,
            column: 17
          }
        }],
        line: 196
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9be16e18595f2286e9f928f2c27633fca81b0ab1"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_k86gbahkc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_k86gbahkc();
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// To meet accessibility standards, the Popover component must receive either title, aria-labelledby, or aria-label.

var CLOSE_TIMEOUT_MS = (cov_k86gbahkc().s[0]++, 500);
var CONTENT_CLASS_NAME = (cov_k86gbahkc().s[1]++, {
  base: 'BricksPopover__Content',
  afterOpen: 'BricksPopover__Content--after-open',
  beforeClose: 'BricksPopover__Content--before-close'
});
var OVERLAY_CLASS_NAME = (cov_k86gbahkc().s[2]++, {
  base: 'BricksPopover__Overlay',
  afterOpen: 'BricksPopover__Overlay--after-open',
  beforeClose: 'BricksPopover__Overlay--before-close'
});
cov_k86gbahkc().s[3]++;
var FullScreenModal = exports.FullScreenModal = function FullScreenModal(_ref) {
  var _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? (cov_k86gbahkc().b[0][0]++, false) : _ref$isOpen,
    onRequestClose = _ref.onRequestClose,
    _ref$headerIconButton = _ref.headerIconButtonVariant,
    headerIconButtonVariant = _ref$headerIconButton === void 0 ? (cov_k86gbahkc().b[1][0]++, 'icon') : _ref$headerIconButton,
    title = _ref.title,
    subtitle = _ref.subtitle,
    id = _ref.id,
    analyticsName = _ref.analyticsName,
    trackBoxImpression = _ref.trackBoxImpression,
    trackButtonImpressions = _ref.trackButtonImpressions,
    onBackClick = _ref.onBackClick,
    _ref$showScrollbar = _ref.showScrollbar,
    showScrollbar = _ref$showScrollbar === void 0 ? (cov_k86gbahkc().b[2][0]++, true) : _ref$showScrollbar,
    _ref$hasPadding = _ref.hasPadding,
    hasPadding = _ref$hasPadding === void 0 ? (cov_k86gbahkc().b[3][0]++, true) : _ref$hasPadding,
    themeProps = _ref.themeProps,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_k86gbahkc().f[0]++;
  var ariaLabelledBy = (cov_k86gbahkc().s[4]++, title ? (cov_k86gbahkc().b[4][0]++, (0, _NavigationBar.getNavigationBarTitleId)({
    id: id
  })) : (cov_k86gbahkc().b[4][1]++, props['aria-labelledby']));
  var ariaLabel = (cov_k86gbahkc().s[5]++, ariaLabelledBy ? (cov_k86gbahkc().b[5][0]++, null) : (cov_k86gbahkc().b[5][1]++, props['aria-label']));
  cov_k86gbahkc().s[6]++;
  (0, _shared.useDisabledBodyScroll)(isOpen);
  var _ref2 = (cov_k86gbahkc().s[7]++, (0, _react.useState)(false)),
    _ref3 = _slicedToArray(_ref2, 2),
    showDivider = _ref3[0],
    setShowDivider = _ref3[1];
  var handleScroll = (cov_k86gbahkc().s[8]++, (0, _react.useCallback)(function (e) {
    cov_k86gbahkc().f[1]++;
    cov_k86gbahkc().s[9]++;
    return setShowDivider(e.currentTarget.scrollTop > 0);
  }, []));
  var _ref4 = (cov_k86gbahkc().s[10]++, (0, _theme.useTheme)()),
    colors = _ref4.colors;
  var contentStyles = (cov_k86gbahkc().s[11]++, {
    height: '100vh',
    width: '100vw',
    outline: 'none',
    border: 'none',
    WebkitOverflowScrolling: 'touch',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column'
  });
  var overlayStyles = (cov_k86gbahkc().s[12]++, {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    zIndex: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: colors.neutrals0,
    overflowY: 'hidden'
  });
  var globalStyles = (cov_k86gbahkc().s[13]++, /*#__PURE__*/(0, _react2.css)(".", OVERLAY_CLASS_NAME.base, "{opacity:0;transition:opacity ", CLOSE_TIMEOUT_MS, "ms ease-out;}.", OVERLAY_CLASS_NAME.afterOpen, "{opacity:1;}.", OVERLAY_CLASS_NAME.beforeClose, "{opacity:0;}.", CONTENT_CLASS_NAME.base, "{transform:translateY(10%);transition:transform ", CLOSE_TIMEOUT_MS, "ms ease-out;}.", CONTENT_CLASS_NAME.afterOpen, "{transform:translateY(0);}.", CONTENT_CLASS_NAME.beforeClose, "{transform:translateY(10%);}" + (process.env.NODE_ENV === "production" ? "" : ";label:globalStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
  cov_k86gbahkc().s[14]++;
  return /*#__PURE__*/_react["default"].createElement(_reactModal["default"], {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    className: CONTENT_CLASS_NAME,
    overlayClassName: OVERLAY_CLASS_NAME,
    closeTimeoutMS: CLOSE_TIMEOUT_MS,
    style: {
      content: contentStyles,
      overlay: overlayStyles
    }
    /*
      Accessibility note: Aria-model indicates the presence of a modal element
      https://www.w3.org/TR/wai-aria-1.2/#aria-modal
    */,
    "aria-modal": isOpen
    /*
      Accessibility note: use the contentLabel prop to provide a label for the modal content
      If the modal is already labeled with visible text, you should specify the element including the label with the aria-labelledby attribute.
      https://reactcommunity.org/react-modal/accessibility/#aria-attributes
      To set aria-labelledby, either (1) pass headerProps.title and let this component set aria-labelledby for you, or (2) pass ariaLabelledBy
      and set it to the id of your custom label
    */,
    aria: {
      labelledby: ariaLabelledBy
    },
    contentLabel: ariaLabel
  }, /*#__PURE__*/_react["default"].createElement(_react2.Global, {
    styles: globalStyles
  }), /*#__PURE__*/_react["default"].createElement(_ODThemeLite.ThemedLite, themeProps, /*#__PURE__*/_react["default"].createElement(_shared.ModalHeader, {
    trackBoxImpression: trackBoxImpression,
    trackButtonImpressions: trackButtonImpressions,
    analyticsName: analyticsName,
    onRequestClose: onRequestClose,
    title: title,
    subtitle: subtitle,
    id: id
    // only shows divider if title is present or when scrolling
    ,
    showDivider: (cov_k86gbahkc().b[6][0]++, !!title) || (cov_k86gbahkc().b[6][1]++, showDivider),
    headerIconButtonVariant: headerIconButtonVariant,
    onBackClick: onBackClick
  }), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    p: hasPadding ? (cov_k86gbahkc().b[7][0]++, 5) : (cov_k86gbahkc().b[7][1]++, 0),
    onScroll: handleScroll,
    overflowY: "scroll",
    flex: 1,
    sx: showScrollbar ? (cov_k86gbahkc().b[8][0]++, {}) : (cov_k86gbahkc().b[8][1]++, {
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      msOverflowStyle: 'none',
      scrollbarWidth: 'none'
    })
  }, props.children)));
};
var _default = exports["default"] = FullScreenModal;